import { useEffect, useState } from "react"

//styling
import myStyles from "../../../styles/assessments/AssessmentScheduleForm.module.css"
import { Dropdown } from "primereact/dropdown"
import { useField } from "formik"
import { getCronTimeUtc } from "./scheduleHelpers"

export default function AssessmentScheduleYearly({
  cronFieldName,
  timeValue,
  refreshCronStatement,
  disabled,
}) {
  const [field, , helpers] = useField(cronFieldName)

  const [day, setDay] = useState(1)
  const [month, setMonth] = useState("01")
  const thirtyDayMonths = ["04", "06", "09", "11"]

  const monthOptions = [
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ]

  useEffect(() => {
    if (field.value !== "") {
      let existingCron = field.value?.split(" ")

      if (existingCron.length === 3) {
        if (existingCron[2].includes("|")) {
          let annual = existingCron[2].split("|")
          setDay(+annual[0].replace("day:", ""))
          setMonth(annual[1].replace("month:", ""))
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let timeValues = getCronTimeUtc(timeValue)

    //Default cron is week days
    let newCron = `${timeValues} day:${day}|month:${month}`

    helpers.setValue(newCron)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [day, month, refreshCronStatement])

  const setDayValue = (day) => {
    switch (month) {
      case "02":
        if (day > 29) {
          day = 29
        }
        break
      default:
        break
    }

    setDay(day)
  }

  const getDayOptions = () => {
    let days = [
      ...Array(31)
        .keys()
        .map((key) => key + 1),
    ]

    if (month === "02") {
      days = days.filter((day) => day <= 29)
    } else if (thirtyDayMonths.includes(month)) {
      days = days.filter((day) => day <= 30)
    }

    return days
  }

  return (
    <div className={myStyles.periodOptionContainer}>
      <div
        className={`${myStyles.periodOption} ${myStyles.periodWeeklyOption}`}
      >
        Select date:
        <Dropdown
          value={day}
          options={getDayOptions()}
          onChange={(e) => {
            setDayValue(e.value)
          }}
          className={myStyles.periodDropdown}
          disabled={disabled}
        />
        <Dropdown
          value={month}
          options={monthOptions}
          onChange={(e) => {
            setMonth(e.value)

            if (e.value === "02" && day > 29) {
              setDay(29)
            } else if (thirtyDayMonths.includes(e.value) && day > 30) {
              setDay(30)
            }
          }}
          className={myStyles.periodDropdown}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
